import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccessThick = props => {
  if (props.id !== "_svgsuccessthick") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fill="#2A7952" d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4zm-1.818 13.316l7.273-7.273 2.424 2.424-9.697 9.698-6.061-6.061 2.424-2.424 3.637 3.636z" fillRule="evenodd" /></svg>;
};

SvgSuccessThick.displayName = "_svgsuccessthick";
SvgSuccessThick.propTypes = {
  id: PropTypes.string
};
SvgSuccessThick.defaultProps = {
  id: ''
};
export default SvgSuccessThick;